import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { State } from 'linkifyjs';
import { SvgIconDirective } from '../../svg-icon/svg-icon.directive';

type componentState = 'password_revealed' | 'password_masked';

@Component({
  selector: 'kgr-password-input-control',
  templateUrl: './password-input-control.component.html',
  styleUrls: ['./password-input-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputControlComponent),
      multi: true,
    },
  ],
  imports: [ReactiveFormsModule, SvgIconDirective],
})
export class PasswordInputControlComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {
  @ViewChild('toggleButton') toggleButton: ElementRef<HTMLButtonElement>;

  @Input() small = false;
  @Input() big = false;

  @Input() autocomplete: 'current-password' | 'new-password' = 'current-password';

  formControl = new FormControl<string>(null);

  state = signal<componentState>('password_masked');

  public onTouched: () => void = () => {};
  private valueChangesSubscription: Subscription;

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.valueChangesSubscription?.unsubscribe();
  }

  ngOnChanges(): void {}

  writeValue(value: any): void {
    this.formControl.setValue(value, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.valueChangesSubscription = this.formControl.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  toggleVisibility() {
    if (this.state() === 'password_revealed') {
      this.state.set('password_masked');
    } else {
      this.state.set('password_revealed');
    }
    this.toggleButton?.nativeElement?.blur();
  }
}
